import React, { memo, useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { postRequest } from '../../../utils/axiosRequests';
import { toast } from 'react-toastify';
import { loginSuccess } from '../../../store/slices/authSlice';
import SignatureView from './views/signatureView';

const Signature = () => {
  const userInfo = useSelector((state) => state.authReducer.data);
  const [doctorName, setDoctorName] = useState(userInfo?.doctorName);
  const [signaturePosition, setSignaturePosition] = useState(
    userInfo?.signaturePosition ?? false,
  );
  const [selectedImage, setSelectedImage] = useState('');
  const dispatch = useDispatch();
  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const handleSignature = () => {
    let formData = new FormData();
    if (selectedImage) {
      formData.append('signature', selectedImage);
    }
    formData.append('doctorName', doctorName);
    formData.append('signaturePosition', signaturePosition);
    postRequest('doctors/upload-signature', formData)
      .then((data) => {
        dispatch(
          loginSuccess({
            ...userInfo,
            doctorName,
            signaturePosition,
          }),
        );
        //setSelectedImage('');
        toast.success('Successfully uploaded', {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        const errorMsg = error.message.split(',');
        toast.error(errorMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <div>
      <Row className="mt-3">
        <Col md={3}>
          <Form.Group controlId="genericName">
            <Form.Check
              type={`radio`}
              id={`fixed`}
              label={`Fixed In Bottom`}
              checked={signaturePosition == true}
              onChange={(e) => setSignaturePosition(true)}
            />
            <Form.Check
              type={`radio`}
              id={`adjustable`}
              label={`Adjustable Position According To Data`}
              checked={signaturePosition == false}
              onChange={(e) => setSignaturePosition(false)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group controlId="formFileSm">
            <Form.Control
              type="file"
              accept="image/*"
              size="sm"
              onChange={imageChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-2 mt-2">
        <Col md={3}></Col>
        <Col md={3}>
          {!selectedImage && <SignatureView />}
          {selectedImage && (
            <div>
              <img
                src={URL.createObjectURL(selectedImage)}
                alt="Thumb"
                height={80}
                width={280}
              />
              <i
                className="fa fa-times-circle ml-3"
                onClick={() => setSelectedImage('')}
                style={{ fontSize: '18px' }}
              ></i>
            </div>
          )}
        </Col>
      </Row>
      <Row className="mb-2">
        <Col md={3}></Col>
        <Col md={3}>
          <Form.Control
            as="textarea"
            rows={3}
            size="sm"
            placeholder="Enter name"
            defaultValue={userInfo?.doctorName}
            onChange={(e) => setDoctorName(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mb-2 mt-2">
        <Col md={3}></Col>
        <Col>
          <Button size="sm" onClick={() => handleSignature()}>
            Save signature
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default memo(Signature);
